import { http } from "@/lib/api";

export const STATUS = {
  draft: ["Draft", "bg-slate-200 text-slate-700"],
  scheduled: ["Scheduled", "bg-blue-100 text-blue-800"],
  published: ["Published", "bg-emerald-100 text-emerald-800"],
};

export const StatusBadge = ({ status, testid }) => {
  const [label, cls] = STATUS[status] || STATUS.draft;
  return <span className={`inline-flex rounded-full px-2.5 py-1 text-xs font-bold ${cls}`} data-testid={testid}>{label}</span>;
};

export const ukDateTime = (iso) => (iso ? new Date(iso).toLocaleString("en-GB", { timeZone: "Europe/London", day: "numeric", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" }) : "");
export const ukDate = (d) => (d ? new Date(d).toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" }) : "");

export const postAction = (id, action, body) => http.post(`/admin/posts/${id}/${action}`, body).then((r) => r.data);
export const deletePost = (id) => http.delete(`/admin/posts/${id}`);
export const createPost = () => http.post("/admin/posts").then((r) => r.data);

export const uploadImage = (file) => {
  const fd = new FormData();
  fd.append("file", file);
  return http.post("/admin/uploads", fd).then((r) => r.data.url);
};
